import {fieldConditionHelper} from "@/form/helpers/field-conditionals.js";

let steps = [
    // Registered
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: '__phone_verification__',
        fields: [
            {
                // label: 'Phone Verification',
                name: 'sms_verification',
                type: 'smsverification',
                value: null,
            },
        ],
        hideButtonsSection: true,
        nextButtonText: '__skip__',
        nextButtonClass: 'btn-secondary',
        hideIfCondition: (app) => {
            return !!app.verified_phone_number && app.verified_phone_number.length == 10;
        }
    },
    {
        beforeCreate: function() {},
        beforeNextStep: 'executeCreateAccount',
        // beforeNextStep: function() {},
        title: "__lets_create_your_account__",
        fields: [
            {
                label: '__email_address__',
                name: 'email',
                placeholder: '',
                as: 'input',
                type: 'text',
                value: null,
                validationRules: 'required|email',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 50
                },
            },
            {
                label: '__confirm_email__',
                name: 'email_confirmation',
                placeholder: '',
                as: 'input',
                type: 'text',
                value: null,
                validationRules: 'required|email|emailConfirmation',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 50,
                    onpaste: "return false;"
                },
            },
            {
                label: '__password__',
                name: 'password',
                placeholder: '',
                as: 'input',
                type: 'password',
                value: null,
                validationRules: 'required|password',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 50
                },
            },
            {
                label: '__confirm_password__',
                name: 'password_confirmation',
                placeholder: '',
                as: 'input',
                type: 'password',
                value: null,
                validationRules: 'required|password|passwordConfirmation',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 50
                },
            },
        ],
        isStepSkippable: true,
        textBottom: `
        <p class="text-muted" style="font-size:14px;">__comparehub_member_pp_tc__</p>
        `,
        hideIfCondition: (app) => {
            if(!app.forcePhoneVerification) {
                return false;
            }
            return !app.verified_phone_number || app.verified_phone_number.length != 10;
        }
    },
];

export default steps;
